import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map, pairwise, takeUntil, tap } from 'rxjs/operators';
import { ExecuteDynamicActionsBrickUserActions } from 'src/app/store/dashboard/brick-wall/brick-behaviour-state/brickTypes/dynamic-actions-behavior/dynamic-actions-behavior.actions';
import { DynamicActionsBehaviorStateDropdownSelectors } from 'src/app/store/dashboard/brick-wall/brick-behaviour-state/brickTypes/dynamic-actions-behavior/dynamic-actions-behavior.dropdown.selectors';
import { IDynamicActionsBrickEntry } from '../../dynamic-actions-brick-configuration/dynamic-actions-brick-configuration';
import { IDynamicActionsBrickLayoutComponent } from '../i-dynamic-actions-brick-layout-component';

@Component({
   selector: 'samweb-dynamic-actions-brick-dropdown-layout',
   templateUrl: './dynamic-actions-brick-dropdown-layout.component.html',
   styleUrls: ['./dynamic-actions-brick-dropdown-layout.component.scss'],
})
export class DynamicActionsBrickDropdownLayoutComponent implements IDynamicActionsBrickLayoutComponent, OnInit, OnDestroy {
   public brickInstanceId: Readonly<string>;

   public items$: Observable<IDynamicActionsBrickEntry[]>;

   private destroy$ = new Subject();
   private selectedItem$: BehaviorSubject<IDynamicActionsBrickEntry> = new BehaviorSubject(null);

   constructor(private store: Store) {}

   ngOnInit(): void {
      this.items$ = this.store.select(DynamicActionsBehaviorStateDropdownSelectors.getSpecificItemsFn).pipe(map((fn) => fn(this.brickInstanceId)));

      this.selectedItem$
         .pipe(
            pairwise(),
            tap(([oldValue, newValue]) => {
               if (!_.isNil(oldValue)) {
                  this.store.dispatch(new ExecuteDynamicActionsBrickUserActions(oldValue.undoActions));
               }
               if (!_.isNil(newValue)) {
                  this.store.dispatch(new ExecuteDynamicActionsBrickUserActions(newValue.actions));
               }
            }),
            takeUntil(this.destroy$)
         )
         .subscribe();
   }

   ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
   }

   selectionChange(actionEntry: IDynamicActionsBrickEntry) {
      this.selectedItem$.next(actionEntry);
   }
}
